import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import { del } from '../../api/api';

export const deleteApplicationStatusSubscription = (applicationStatusSubscriptionId: number) =>
  createGenericDispatcher<ApplicationStatusSubscription>({
    name: 'DELETE_APPLICATION_STATUS_SUBSCRIPTION',
    loadFunction: () => del(`/application-status-subscription/${applicationStatusSubscriptionId}`),
    args: { applicationStatusSubscriptionId },
  });
